import React, { useState } from "react";
import "../styles/Services.css";
import { AiOutlineArrowRight } from "react-icons/ai";
import { FaMinus, FaPlus } from "react-icons/fa";
import { RiArrowRightSLine } from "react-icons/ri";
import servicebgImg from "../bg_images/S_app_bg_img.png";

const Servicesfaqs = [
  {
    question: "How much does it cost to pay a company to build an app?",
    answer:
      "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Molestias inventore iure tempore possimus nisi assumenda at saepe. Iste, voluptatum veniam.",
  },
  {
    question: "How long does it take to develop an app?",
    answer:
      "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Molestias inventore iure tempore possimus nisi assumenda at saepe. Iste, voluptatum veniam.",
  },
  {
    question: "What technologies are best for app development?",
    answer:
      "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Molestias inventore iure tempore possimus nisi assumenda at saepe. Iste, voluptatum veniam.",
  },
  {
    question: "Can I update my app after it's launched?",
    answer:
      "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Molestias inventore iure tempore possimus nisi assumenda at saepe. Iste, voluptatum veniam.",
  },
];


const Services = () => {
  
  const [ServicesopenIndex, ServicessetOpenIndex] = useState(null); // Removed `number | null`

  const handleToggle = (index) => {
    ServicessetOpenIndex(ServicesopenIndex === index ? null : index);
  };
 

  return (
    <div className="Service_Container">
      {/* Cousals end */}

      <div
        className="Service_sec1"
        style={{ backgroundImage: `url(${servicebgImg})`,backgroundSize: "cover",
  backgroundPosition: "center",
  backgroundRepeat: "no-repeat",
  width: "98.5vw", }}
      >
        <section className="Service_sec1_one">
          <h5>
            Services{" "}
            <span>
              <RiArrowRightSLine className="servrighticon" />
            </span>{" "}
            Application development
          </h5>
          <h2>Transform Ideas Into Impactful Applications</h2>
          <p>
            Arshil combines technical expertise and innovation to deliver custom
            web and mobile applications that empower businesses to grow and
            succeed
          </p>
        </section>
        {/* <section>
          <img
            className="ServiceHeroImg"
            src="images/ServiceHeroImg.png"
            alt=""
          />
        </section> */}
      </div>

      {/* Sec 2  */}

      <div className="Service_sec2">
        <section className="Service_sec2_in1">
          <h2>What we Offer as an Application Development Company</h2>
          <section className="Service_sec2_in1_h4C">
            <section>
              <img
                className="Service_sec3_img1"
                src="images/s_sec2_img1.png"
                alt=""
              />
            </section>

            <section>
              <h4 className="Service_sec2_in1_h4C_container">
                <span className="Service_sec2_in1_h4C_container_span">
                  Custom Web Application Development:
                </span>{" "}
                Scalable and robust web solutions designed to meet your business
                goals.
              </h4>
            </section>
          </section>
          <section className="Service_sec2_in1_h4C">
            <section>
              <img
                className="Service_sec3_img1"
                src="images/s_sec2_img2.png"
                alt=""
              />
            </section>

            <section>
              <h4 className="Service_sec2_in1_h4C_container">
                <span className="Service_sec2_in1_h4C_container_span">
                  Mobile Application Development:
                </span>{" "}
                intuitive Android and iOS apps that captivate users and drive
                engagement.
              </h4>
            </section>
          </section>
          <section className="Service_sec2_in1_h4C">
            <section>
              {" "}
              <img
                className="Service_sec3_img1"
                src="images/s_sec2_img3.png"
                alt=""
              />
            </section>

            <section>
              <h4 className="Service_sec2_in1_h4C_container">
                <span className="Service_sec2_in1_h4C_container_span">
                  Custom Web Application Development:{" "}
                </span>{" "}
                Cloud-Based Application Development: Secure and efficient
                cloud-native apps for modern business needs.
              </h4>
            </section>
          </section>
          <section className="Service_sec2_in1_h4C">
            <section>
              {" "}
              <img
                className="Service_sec3_img1"
                src="images/s_sec2-img4.png"
                alt=""
              />
            </section>

            <section>
              <h4 className="Service_sec2_in1_h4C_container">
                <span className="Service_sec2_in1_h4C_container_span">
                  Enterprise Application Development:
                </span>{" "}
                Advanced solutions that streamline operations and enhance
                productivity.
              </h4>
            </section>
          </section>
          <section className="Service_sec2_in1_h4C">
            <section>
              {" "}
              <img
                className="Service_sec3_img1"
                src="images/s_sec2_img5.png"
                alt=""
              />
            </section>

            <section>
              <h4 className="Service_sec2_in1_h4C_container">
                <span className="Service_sec2_in1_h4C_container_span">
                  AI-powered web applications:
                </span>{" "}
                We embrace the latest advancements in AI to create intelligent,
                adaptive web applications that enhance user experiences and
                drive business growth. AI-powered web applications: We embrace
                the latest advancements in AI to create intelligent, adaptive
                web applications that enhance user experiences and drive
                business growth.
              </h4>
            </section>
          </section>
          {/* <section className="Service_sec2_in1_h4C">
            <section>
              {" "}
              <img
                className="Service_sec3_img1"
                src="images/s_sec2_img5.png"
                alt=""
              />
            </section>

            <section>
              <h4 className="Service_sec2_in1_h4C_container">
                <span className="Service_sec2_in1_h4C_container_span">
                  
                </span>{" "}
                We embrace the latest advancements
                in AI to create intelligent, adaptive web applications that
                enhance user experiences and drive business growth.
                AI-powered web applications: We embrace the latest advancements in AI to create intelligent, adaptive web applications that enhance user experiences and drive business growth.
              </h4>
            </section>
          </section> */}

          <section>
            <button className="Service_sec2_in1_button">
              Get a Free Quote{" "}
              <AiOutlineArrowRight className="s_sec2demoarrow" />
            </button>
          </section>
        </section>

        <section>
          <img className="s_sec2_img1" src="images/s_sec_img1.png" alt="" />
        </section>
      </div>

      {/* Sec 3 */}
      <div className="Service_sec3">
        <section className="Service_sec3_one">
          <h2>Why Choose Arshil as Your Application Developement partner?</h2>
          <p>
            At Arshil, we use our state-of-the-art platform, Akscel, designed to
            empower organizations to rapidly build and deploy applications with
            minimal resources, saving cost, time, effort, and human resources.
            Akscel makes it easier for us to deliver excellence and maximise
            resources.With Akscel, we accelerate development cycles and enhance
            project efficiency while ensuring enterprise-grade quality. Schedule
            a demo to see Akscel in action. Here's why businesses trust us:
          </p>
        </section>

        <section className="Service_sec3_two">
          <section className="Service_sec3_two-in1">
            <img src="images/s_sec3_img1.png" alt="" />
            <h5>Rapid Development</h5>
          </section>

          <section className="Service_sec3_two-in1">
            <img src="images/s_sec3_img3.png" alt="" />
            <h5>Scalable Designs</h5>
          </section>

          <section className="Service_sec3_two-in1">
            <img src="images/s_sec3_img5.png" alt="" />
            <h5> Cost-Effective Solutions</h5>
          </section>
          <section className="Service_sec3_two-in1">
            <img src="images/s_sec3_img6.png" alt="" />
            <h5> Expert Team</h5>
          </section>
          <section className="Service_sec3_two-in1">
            <img src="images/s_sec3_img7.png" alt="" />
            <h5> Client-Centric Approach</h5>
          </section>
          <section className="Service_sec3_two-in1">
            <img src="images/s_sec3_img8.png" alt="" />
            <h5> Agile and Flexible Development process</h5>
          </section>
        </section>
      </div>

      {/* sec 4  */}

      <div className="Service_sec4">
        <h1> Our Approach to delivering state-of-the-art Applications </h1>
        <p>
          {" "}
          At Arshil, we start by understanding your vision, then craft solutions
          using proven methodologies and advanced technologies. Here is our
          approach to delivering high-quality applications{" "}
        </p>
        <ul className="Service_sec4_ul">
          <li>Understanding Your Needs </li>
          <li>User-Centered Design</li>
          <li>Agile Development</li>
          <li>Security First</li>
          <li>Scalability</li>
          <li>Collaboration and Transparency</li>
          <li>Quality Assurance</li>
        </ul>
      </div>

      {/* Sec 5 */}

      <section className="Service_sec5_in1_FaQ">
        <h1 className="Service_sec5_in1_FaQ_h1">
          Frequently Asked Questions (FAQs)
        </h1>
        {Servicesfaqs.map((faq, index) => (
          <div key={index} className="Service_sec5_in1_FaQ-in1">
            <div className="faq-header" onClick={() => handleToggle(index)}>
              <h5>{faq.question}</h5>
              <span className="icon">
                {ServicesopenIndex === index ? <FaMinus /> : <FaPlus />}
              </span>
            </div>
            {ServicesopenIndex === index && (
              <p className="faq-answer">{faq.answer}</p>
            )}
          </div>
        ))}
      </section>

      {/* Dummy */}

      {/* coursal section */}
    </div>
  );
};

export default Services;
